var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-confirm',{attrs:{"confirm-title":"cart.confirm_the_action","description":"cart.description_confirm_the_action"},on:{"confirm":function($event){return _vm.$emit('confirm')},"cancel":function($event){return _vm.$emit('closeModal')}}},[_c('icon-warning',{attrs:{"size":70}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }